import {Button, Flex, Loader, Paper, Select, Switch, Tooltip, UnstyledButton} from "@mantine/core";
import React, {Fragment, useState} from "react";
import classes from "../css/Results.module.css";
import {useTranslation} from "react-i18next";
import LanguageSelect from "./LanguageSelect";


export default function TopNavbar( {loading, logout, openExportDrawer, toggleRefresh, isMobile, refreshPage}) {
    let size = "md"
    if(isMobile){
        size = "sm"
    }
    const { t } = useTranslation();
 return(<>
     <Paper shadow="md">
         <Flex
             id="bar"
             mih={50}
             bg="#147DC2"
             gap="xl"
             justify="flex-end"
             align="flex-start"
             direction="row"
             wrap="nowrap"
             p="xs"
             sx={(theme) => ({
                 boxShadow: theme.shadows.lg, // Add shadow here
             })}
         >
             <UnstyledButton size="xl" pt="xs" ff="heading" flex="auto" fw={700}
                   c="white" onClick={refreshPage}>
                 ORION® Status Checker
             </UnstyledButton>
             {!isMobile ? (<LanguageSelect />):(<Fragment/>)}
             {loading && (<Loader color="rgba(255, 255, 255, 1)" style={{marginRight: "-25px"}} />)}
             {toggleRefresh ? (<Tooltip multiline
                                        w={220}
                                        withArrow transitionProps={{ transition: 'slide-down', duration: 300 }} openDelay={300} position="top" label={t("refresh-tip")}><div><Switch
                 className={classes.autoRefreshSwitch} size={size} pt="xs" checked={loading}
                 onChange={toggleRefresh} fw={600} label={t("Auto-Refresh")} c="white"/></div>
             </Tooltip>) : <Fragment/> }

             { openExportDrawer ?  (<Button size={size} onClick={openExportDrawer}
                     name="btn" id="btn">{t("Export")}</Button>) : <Fragment/>}
             { (!isMobile && logout) ? (<Button size={size} onClick={logout} name="btn"
                                id="btn">{t("Logout")}</Button>) : <Fragment/>}
         </Flex>
     </Paper>

 </>)
}